import React from 'react';
import { getCouponPeriodText } from '../../../../lib/utils/couponUtils';

const CouponPeriod = (props) => {
  return <div>{getCouponPeriodText({ ...props })}</div>;
};

export default CouponPeriod;
